import { t } from "@lingui/macro";
import { Chip } from "@mui/material";
import { formatSentenceCase } from "../../helpers/formatSentenceCase";

export interface UserAccessStatusChipProps {
  isLockedOut: boolean | null | undefined;
}

export function UserAccessStatusChip({
  isLockedOut,
}: UserAccessStatusChipProps) {
  const locked = Boolean(isLockedOut);
  return (
    <Chip
      label={
        locked
          ? formatSentenceCase(t`Locked out`)
          : formatSentenceCase(t`Enabled`)
      }
      variant="filled"
      size="medium"
      color={locked ? "warning" : "success"}
      sx={{
        width: "fit-content",
        fontWeight: 500,
        backgroundColor: locked ? "rgb(255, 87, 87)" : "rgb(0, 168, 39)",
        color: "#fff",
      }}
    />
  );
}
